

























import { defineComponent } from '@vue/composition-api';
import { t } from '../../../helpers/translation.helper';
import LinkButton from '../../components/LinkButton.vue';

export default defineComponent({
  components: {
    LinkButton,
  },
  props: {
    showReOpenCommentButton: {
      type: Boolean,
      required: true,
    },
    showViewEntireThreadButton: {
      type: Boolean,
      required: true,
    },
    showGoToCommentButton: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    return { t };
  },
});
